export const MainWrapperVariants = {
    initial:{
        scale: 0.9,
        opacity: 0
    },
    animate:{
        scale: 1,
        opacity: 1,
        transition:{
            type: "tween",
            duration: 0.6
        }
    },
    exit: {
        opacity: 0.9,
        transition: {
            type: "tween",
            duration: 0.2
        }
    }
}

export const MainNameVariants = {
    initial: {
        x: -500,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.9
        }
    }
}
export const MainLine1Variants = {
    initial: {
        x: -500,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.6,
            delay: 0.2
        }
    }
}
export const MainLine2Variants = {
    initial: {
        x: -500,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.6,
            delay: 0.3
        }
    }
}
export const MainRoleVariants = {
    initial: {
        x: -500,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.6,
            delay: 0.3
        }
    }
}

export const Layer1Variants = {
    initial: {
        x: 900,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.8,
            delay: 0.1
        }
    },
    exit: {
        x: 900,
        opacity: 0,
        transition: {
            type: 'tween',
            duration: 0.5,
            delay: 0.1
        }
    },
}
export const Layer2Variants = {
    initial: {
        x: 900,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.6,
            delay: 0.4
        }
    },
    exit: {
        x: 900,
        opacity: 0,
        transition: {
            type: 'tween',
            duration: 0.3,
            delay: 0.4
        }
    },
}
export const Layer3Variants = {
    initial: {
        x: 900,
        opacity: 0
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            duration: 0.6,
            delay: 0.1
        }
    },
    exit: {
        x: 900,
        opacity: 0,
        transition: {
            type: 'tween',
            duration: 0.5,
            delay: 0.3
        }
    },
}

export const MainBtnVariants = {
    initial: {
        y: 100,
    },
    animate: {
        y: 0,
        transition: {
            type: 'tween',
            duration: 0.6,
            delay: 0.3
        }
    }
}